<template>
  <v-container fluid color="white--text">
    <!--callback-->
    <RegisterCallback/>
    <!--END callback-->
    <!--BEGIN IPN-->
    <SasaPayIPN/>
    <!--END IPN-->
    <v-container fluid>
      <v-card elevation="5">
        <v-card-text>
          <v-row class="mt-10">
            <v-divider/>
            <v-col cols="12" md="5">
              <v-card flat>
                <v-card-text>
                  <h3>Make payment requests from your customer</h3>
                  <p>
                    Merchants can request payment from a customer either using customer mobile number or SasaPay alias number.
                  </p>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  EndPoints:<br/>
                  <div class="secondary" style="color: #e7e3fc">
                    <strong>Sandbox</strong>
                    <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/payments/request-payment/"}}</p>
                    <v-divider/>
                    <strong>Production</strong>
                    <p class="ma-2">{{"https://api.sasapay.app/api/v1/payments/request-payment/"}}</p>
                  </div>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  Request Parameters <br/>
                  <div class="ma-4">
                    <span class="p4"><v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantCode</code>:  Sasa<span class="error--text">Pay</span> Till/Paybill number. <br/></span>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>NetworkCode</code>:  Sasa<span class="error--text">Pay</span>(0) 63902(MPesa) 63903(AirtelMoney) 63907(T-Kash) <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>PhoneNumber</code>:  &nbsp; Payer Mobile Number <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>TransactionDesc</code>: &nbsp;  Transaction description<br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>AccountReference</code>:   &nbsp;  Identifier of the payment request<br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>Currency</code>:  &nbsp; Kenyan Shillings (KES) <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>Amount</code>:  Amount requested. <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>CallBackURL</code>:  URL to receive payment results <br/>
                  </div>

                </v-card-text>
                <v-divider/>
                <v-card-text>
                  Expected Results:<br/>

                  Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="7" class="">
              <h3>Sample Request</h3>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="code"
                  @lang="changeLanguage"
                  :wrap_code="false"
                  :language_selector="true"
                  class="github_dark"
                  :copy_code="true"
                  font_size="14px"
                  width="100%"
                  :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
              ></code-editor>
              <v-divider/>
              <h3>Sample Response</h3>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="response"
                  :wrap_code="false"
                  :language_selector="true"
                  class="github_dark"
                  :copy_code="true"
                  font_size="14px"
                  width="100%"
                  :languages="[['json','JSON']]"
              ></code-editor>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container fluid>
      <v-card elevation="5">
        <v-card-text>
          <!--process payment-->
          <v-row class="mt-5">
            <v-divider/>
            <v-col cols="12" md="6">
              <v-card flat>
                <v-card-text>
                  <h3>Process Payment</h3>
                  <p>
                    After the payment request you will need to process the transaction by making a POST call to the following endpoint:
                  </p>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  EndPoints:<br/>
                  <div class="secondary ma-5"  style="color: #e7e3fc">
                    <strong>Sandbox</strong>
                    <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/payments/process-payment/"}}</p>
                  </div>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  Request Parameters <br/>
                  <div class="ma-4">
                    <span class="p4"><v-icon color="primary">mdi-access-point-check</v-icon> <code>CheckoutRequestID</code>: &nbsp;  A unique identifier of the transaction request. <br/></span>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantCode</code>: &nbsp; A unique number assigned to an organization/merchant registered with SasaPay.<br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>VerificationCode</code>:  &nbsp; his is a 6 digit code sent to a mobile number making payment. <br/>
                  </div>

                </v-card-text>
                <v-divider/>
                <v-card-text>
                  Expected Results:<br/>

                  Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="">
              <h3>Sample Request</h3>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="processPaymentCode"
                  :wrap_code="false"
                  :language_selector="true"
                  @lang="changeLanguage"
                  class="github_dark"
                  :copy_code="true"
                  font_size="14px"
                  width="100%"
                  :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
              ></code-editor>
              <v-divider/>
              <h3>Sample Response</h3>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="processPaymentResponse"
                  :wrap_code="false"
                  :language_selector="true"
                  class="github_dark"
                  :copy_code="true"
                  font_size="16px"
                  width="100%"
                  :languages="[['json','JSON']]"
              ></code-editor>
              <h3>Sample Callback Result</h3>
              <code-editor
                  :read_only="true"
                  theme="dark"
                  v-model="processPaymentIpn"
                  :wrap_code="false"
                  :language_selector="true"
                  class="github_dark"
                  :copy_code="true"
                  font_size="14px"
                  width="100%"
                  :languages="[['json','JSON']]"
              ></code-editor>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <ScrollDownIcon/>
    </v-container>
  </v-container>
</template>

<script>

import {getC2BMakeRequestResponse, getRegisterURLC2B} from "../../../../../shared/snippets/c2b/makeRequests";
import {
  getC2BProcessRequestResponse,
  getCallbackIPN,
  processPaymentC2B
} from "../../../../../shared/snippets/c2b/processPayment";
import ScrollDownIcon from "../../../../../shared/scroller/ScrollDownIcon.vue";
import RegisterCallback from "@/packages/c2bModules/SasaPayC2B/components/RegisterCallback.vue";
import SasaPayIPN from "@/packages/c2bModules/SasaPayIPN/view/IPN.vue";

export default {
  name: "C2B",
  components: {SasaPayIPN, RegisterCallback, ScrollDownIcon},
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
    processPaymentCode:"",
    processPaymentResponse:"",
    processPaymentIpn:""
  }),
  mounted() {
    this.importSnippets('php')//
    this.importResponse();
    //process payment
    this.importProcessPayment('php')
    this.importProcessPaymentResponse()
    this.importProcessPaymentResultIPN();
  },
  methods:{
    importSnippets(lang){
      this.code=getRegisterURLC2B(lang)
    },
    importResponse(){
      this.response=getC2BMakeRequestResponse()
    },
    changeLanguage(val) {
      this.importSnippets(val)
    },
    //
    importProcessPayment(lang){
      this.processPaymentCode=processPaymentC2B(lang)
    },
    importProcessPaymentResponse(){
      this.processPaymentResponse=getC2BProcessRequestResponse()
    },
    importProcessPaymentResultIPN(){
      this.processPaymentIpn=getCallbackIPN()
    },
    changeProcessPaymentLanguage(val) {
      this.importProcessPayment(val)
    }
  }
}
</script>

<style scoped>

</style>